import { HttpClient } from '@angular/common/http';
import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import * as $ from 'jquery';
import { AlertService } from '../../services/Alert/alert.service';

@Component({
  selector: 'app-order-online',
  templateUrl: './order-online.component.html',
  styleUrls: ['./order-online.component.scss']
})
export class OrderOnlineComponent implements OnInit, AfterViewInit {
  deliveryOption: string = 'delivery';
  selectedLat: number = 0;
  selectedLng: number = 0;
  selectedAddress: string = '';

  constructor(private http: HttpClient,private router: Router,private alertService: AlertService) { }

  ngOnInit() {
    const savedOption = localStorage.getItem('deliveryOption');
    this.deliveryOption = savedOption || 'delivery';
    if(!savedOption){
      this.setDeliveryOption('delivery')
    }
    localStorage.removeItem('selectedLng');
    localStorage.removeItem('selectedLat');
    localStorage.removeItem('selectedAddress');
    this.selectedLat = localStorage.getItem('selectedLat') ? parseFloat(localStorage.getItem('selectedLat')) : 0;
    this.selectedLng = localStorage.getItem('selectedLng') ? parseFloat(localStorage.getItem('selectedLng')) : 0;
    this.selectedAddress = localStorage.getItem('selectedAddress') || '';
    // if(this.selectedLat || this.selectedLng){ 
    //    console.log(this.selectedLat);
    //    console.log(this.selectedLng);
    // }
  }

  @ViewChild('gmap', { static: true }) gmapElement!: ElementRef;
  map!: google.maps.Map;
  marker!: google.maps.Marker;
  autocomplete!: google.maps.places.Autocomplete;

  ngAfterViewInit(): void {
    console.log('ngAfterViewInit');
    this.initMap();
    this.initAutocomplete();
  }

  initMap(): void {
    let defaultLocation;
    
    // Use saved location if available, otherwise use San Francisco
    if (this.selectedLat !== 0 && this.selectedLng !== 0) {
      defaultLocation = new google.maps.LatLng(this.selectedLat, this.selectedLng);
    } else {
      defaultLocation = new google.maps.LatLng(37.7749, -122.4194); // San Francisco
      this.selectedLat = 0;
      this.selectedLng = 0;
      this.selectedAddress = '';
    }

    this.map = new google.maps.Map(this.gmapElement.nativeElement, {
      center: defaultLocation,
      zoom: 12
    });

    const geocoder = new google.maps.Geocoder();
    const updateAddressFromMarker = (position: google.maps.LatLng) => {
      geocoder.geocode({ location: position }, (results, status) => {
        if (status === 'OK' && results && results[0]) {
          const address = results[0].formatted_address;
          
          // Update marker title to show address on hover
          this.marker.setTitle(address);
          
          // Store address in localStorage
          localStorage.setItem('selectedAddress', address);
          this.selectedAddress = address;
          
          // Optional: Update address input field if it exists
          const addressInput = document.getElementById('addressInputAutoComplete') as HTMLInputElement;
          if (addressInput) {
            addressInput.value = address;
          }
        }
      });
    };

    this.marker = new google.maps.Marker({
      position: defaultLocation,
      map: this.map,
      title: 'Selected Location',
      draggable: true // Allow marker to be dragged
    });
    
    // Listen for marker drag events
    this.marker.addListener('dragend', () => {
      const position = this.marker.getPosition();
      if (position) {
        this.selectedLat = position.lat();
        this.selectedLng = position.lng();
        localStorage.setItem('selectedLat', this.selectedLat.toString());
        localStorage.setItem('selectedLng', this.selectedLng.toString());
        updateAddressFromMarker(position);
      }
    });
  }

  placeName: string = '';
  private bayonneDeliveryZone = [
    {lat:40.642, lng:-74.148},
    {lat:40.650, lng:-74.086},
    {lat:40.727, lng:-74.020},
    {lat:40.737, lng:-74.086},
    {lat:40.642, lng:-74.148}
  ];
  initAutocomplete(): void {
    const input = document.getElementById('addressInputAutoComplete') as HTMLInputElement;
    this.autocomplete = new google.maps.places.Autocomplete(input, {
      componentRestrictions: { country: 'us' },
      fields: ['geometry', 'formatted_address', 'address_components']
    });

    this.autocomplete.addListener('place_changed', async () => {
      const place = this.autocomplete.getPlace();
      if (!place.geometry) {
        this.alertService.danger('Please select a valid address from the suggestions');
        return;
      }

      // Corrected condition with proper parentheses
      const inBayonne = place.address_components?.some(comp => 
        (comp.types.includes('locality') && ['Bayonne'].includes(comp.long_name)) ||
        (comp.types.includes('postal_code') && ['07002', '07305', '07304'].some(zip => comp.long_name.startsWith(zip))
      ));

      console.log('Address Components:', place.address_components);
      console.log('In Bayonne Check:', inBayonne);

      if (!inBayonne) {
        this.handleOutOfZone(input);
        return;
      }

      const location = place.geometry.location;
      const isInZone = await this.checkDeliveryZone(location.lat(), location.lng());
      
      if (!inBayonne) { //isInZone
        this.handleOutOfZone(input);
      } else {
        this.selectedLat = location.lat();
        this.selectedLng = location.lng();
        this.placeName = place.formatted_address;
        this.marker.setPosition(location);
        this.selectedAddress = place.formatted_address;
        localStorage.setItem('selectedLat', this.selectedLat.toString());
        localStorage.setItem('selectedLng', this.selectedLng.toString());
        localStorage.setItem('selectedAddress', place.formatted_address);
      }
    });
  }
  private handleOutOfZone(input: HTMLInputElement): void {
    this.alertService.danger('Sorry, we only deliver within Bayonne, NJ');
    input.value = '';
    this.selectedLat = null;
    this.selectedLng = null;
    this.placeName = '';
  }
  private isPointInPolygon(point: {lat: number, lng: number}, polygon: any[]): boolean {
    // Ray-casting algorithm
    let inside = false;
    for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
      const xi = polygon[i].lat, yi = polygon[i].lng;
      const xj = polygon[j].lat, yj = polygon[j].lng;
      
      const intersect = ((yi > point.lng) !== (yj > point.lng)) &&
        (point.lat < (xj - xi) * (point.lng - yi) / (yj - yi) + xi);
      if (intersect) inside = !inside;
    }
    return inside;
  }
  async checkDeliveryZone(lat: number, lng: number): Promise<boolean> {
    console.log('Checking coordinates:', lat, lng);
    
    const inBounds = this.isInBayonneBounds(lat, lng);
    console.log('In rough bounds:', inBounds);
    
    const inPolygon = this.isPointInPolygon({lat, lng}, this.bayonneDeliveryZone);
    console.log('In precise polygon:', inPolygon);
    
    return inPolygon;
  }
  private isInBayonneBounds(lat: number, lng: number): boolean {
    // Simple rectangular bounds check first for performance
    return (
      lat >= 40.6412 && // Southern boundary
      lat <= 40.6689 && // Northern boundary
      lng >= -74.1147 && // Western boundary
      lng <= -74.0279   // Eastern boundary
    );
  }
  // initAutocomplete(): void {
  //   const input = document.getElementById('addressInputAutoComplete') as HTMLInputElement;
  //   this.autocomplete = new google.maps.places.Autocomplete(input, {
  //     componentRestrictions: { country: 'us' },
  //     fields: ['geometry', 'formatted_address'],
  //   });

  //   this.autocomplete.addListener('place_changed', () => {
  //     const place = this.autocomplete.getPlace();
  //     if (!place.geometry) {
  //       console.warn('Place has no geometry');
  //       return;
  //     }

  //     const location = place.geometry.location;
  //     const address = place.formatted_address;

  //     this.map.setCenter(location);
  //     this.map.setZoom(15);

  //     this.marker.setPosition(location);
  //     this.selectedLat = location.lat();
  //     this.selectedLng = location.lng();
  //     this.selectedAddress = address;

  //     localStorage.setItem('selectedLat', this.selectedLat.toString());
  //     localStorage.setItem('selectedLng', this.selectedLng.toString());
  //     localStorage.setItem('selectedAddress', address);
  //   });
  // }

  setDeliveryOption(option: string) {
    this.deliveryOption = option;
    localStorage.setItem('deliveryOption', option);
  }

  isLocationSelected(): boolean {
    return this.selectedLat !== 0 && this.selectedLng !== 0;
  }

  stepNumTwo: boolean = false;
  firstStepCompleted() {
    // $('.map-section').addClass('hide');
    setTimeout(() => {
      if(this.selectedLat && this.selectedLng && this.selectedAddress){
        // this.stepNumTwo = true;
        setTimeout(() => {
          this.router.navigate(['/menu']);
          // $('.mainMenu').addClass('show');
        }, 50);
      }
    }, 500);
  }

  quantity: number = 1;
  increaseQuantity() {
      if (this.quantity < 99) {
          this.quantity++;
      }
  }
  decreaseQuantity() {
      if (this.quantity > 1) {
          this.quantity--;
      }
  }
  addToCart() {
      // Implement your add to cart logic here
      console.log(`Added ${this.quantity} items to cart`);
      // You'll likely want to emit an event or call a service here
  }

  // ngOnDestroy() {
  //   console.log('ngOnDestroy');
  //   localStorage.removeItem('deliveryOption');
  //   localStorage.removeItem('selectedLat');
  //   localStorage.removeItem('selectedLng');
  // }
}